import ReturnedArticleModal from "./ReturnedArticleModal";

export default ReturnedArticleModal;
